export const DATE_CONFIGURATIONS = {
  time: {
    formats: {
      model: 'HH:mm:ss',
      view : 'hh:mm A'
    },
    validation: /^((0?\d|1[0-2]):?([0-5]\d)?\s?(AM|PM|A|P)?)$|^([01]?\d|2[0-3]):?([0-5]\d)?$/i
  }
};
